import React, {useRef} from 'react';
import {useParams} from 'react-router-dom';
import CardsHeader from 'layouts/Headers/CardsHeader.js';


import {PaymentContextProvider} from '../context';

import {Container,} from "reactstrap";

import AddNewPaymentContent from './AddNewPaymentContent';

export default function Payment() {
  const { id } = useParams();

  return (
    <PaymentContextProvider id={id}>
      <CardsHeader name="Deal" parentName="Payment management" currentName="List" />
      <Container className="mt--5 admin-main-body" fluid >
        <AddNewPaymentContent/>
      </Container>
    </PaymentContextProvider>
  )
}